import { useFpCampaignCartService } from '@cart-services/hooks/useFpCampaignCartService'
import { useFpCampaignCouponService } from '@cart-services/hooks/useFpCampaignCouponService'
import { useFpCampaignSetDefaultValues } from '@cart-services/hooks/useFpCampaignSetDefaultValues'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { MemberLogins } from '@hooks-api/types/dataModel/fortuneCampaign'
import { Box } from '@pets-ui/Box/Box'
import { Container } from '@pets-ui/Container/Container'
import { HStack } from '@pets-ui/HStack/HStack'
import { Link } from '@pets-ui/Link/Link'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { CardGiveaways } from '../CardGiveaways/CardGiveaways'
import { CardOrderDetail } from '../CardOrderDetail/CardOrderDetail'
import { CartAddonProducts } from '../CartAddonProducts/CartAddonProducts'
import { CartEmpty } from '../CartEmpty/CartEmpty'
import { CartFooter } from '../CartFooter/CartFooter'
import { CartGiveawayDeliveryOptions } from '../CartGiveawayDeliveryOptions/CartGiveawayDeliveryOptions'
import { useContextCampaignCart } from '../CartProvider/CampaignCartProvider'
import { CartRegularGiveawayTips } from '../CartRegularGiveawayTips/CartRegularGiveawayTips'
import { CardShipping } from '../CartShipping/CartShipping'
import { CartListItems } from './CartListItems'

export const CartBasic = () => {
  const isDesktop = useResponsive('desktop')
  const { campaignId, countryCode, campaignCode } = useContextCampaignCart()
  const { destructuredData: campaignMember } = useApiCampaignMember({ code: campaignCode })
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCode)
  const { isCartEmpty } = useFpCampaignCartService(campaignId)
  const { clearInvalidSelectedGiveaways, clearInvalidManualInputCouponIds } = useFpCampaignCouponService(campaignId, countryCode, campaignCode)
  const history = useHistory()
  const shouldShowGuidedLogin = exhibitorSettings?.member_login_type === MemberLogins.SUGGEST && !campaignMember
  const { setDefaultIsGiveawayDispatch } = useFpCampaignSetDefaultValues(campaignId, campaignCode)

  useEffect(() => {
    setDefaultIsGiveawayDispatch()
  }, [setDefaultIsGiveawayDispatch])

  const handleLogin = () => {
    history.push('login', {
      referrer: window.location.href,
    })
  }

  useEffect(() => {
    clearInvalidSelectedGiveaways()
  }, [clearInvalidSelectedGiveaways])

  useEffect(() => {
    clearInvalidManualInputCouponIds()
  }, [clearInvalidManualInputCouponIds])

  return (
    <>
      <Container p="12px" maxWidth={1280} minHeight="calc(100vh - 117px - 56px)" height="100%">
        {isCartEmpty
          ? <CartEmpty environment="campaign" campaignCode={campaignCode} />
          : (
            <VStack gap={3} maxWidth={1244}>
              {shouldShowGuidedLogin && (
                <Paper p="12px" elevation={0}>
                  <HStack justifyContent="space-between" alignItems="center" flexWrap="nowrap" gap={4}>
                    <Text color={colors.grey600}>登入會員，即可享受「追蹤貨態、查詢訂單」等官網服務</Text>
                    <Box cursor="pointer" minWidth={60}><Link onClick={handleLogin}>登入會員</Link></Box>
                  </HStack>
                </Paper>
              )}
              <CartGiveawayDeliveryOptions />
              {
                isDesktop
                  ? (
                    <HStack gap={3}>
                      <VStack gap={3} width={900}>
                        <CartListItems />
                        <CartRegularGiveawayTips />
                        <CardGiveaways />
                        <CartAddonProducts />
                      </VStack>
                      <VStack gap={3}>
                        <CardShipping />
                        <CardOrderDetail />
                      </VStack>
                    </HStack>
                  )
                  : (
                    <VStack gap={3}>
                      <CardShipping />
                      <CartListItems />
                      <CartRegularGiveawayTips />
                      <CardGiveaways />
                      <CartAddonProducts />
                    </VStack>
                  )
              }
            </VStack>
          )}
      </Container>
      <CartFooter />
    </>
  )
}
